import * as Sentry from "@sentry/react";
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { store } from './store'
import ErrorBoundaryFallback from './components/common/ErrorBoundaryFallback'
import './index.css'
import App from './App.jsx'

const sentryDsn = import.meta.env.VITE_SENTRY_DSN !== undefined
  ? import.meta.env.VITE_SENTRY_DSN
  : "https://0e755f6978687ceb4536dee408797d5b@sentry.alabproject.in/51";

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    tracePropagationTargets: ["localhost", /^https:\/\/admin\.greendrivemobility\.(com|in)/],
  });
}

// Expose Sentry in development for easy console testing
if (import.meta.env.DEV) {
  window.Sentry = Sentry;
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={({ error, resetError, eventId }) => (
      <ErrorBoundaryFallback error={error} resetError={resetError} eventId={eventId} />
    )}>
      <Provider store={store}>
        <App />
      </Provider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
)



